import Icon from '../components/Icon.vue'

Icon.register({
  'hospital-symbol': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 0c141.4 0 256 114.6 256 256s-114.6 256-256 256-256-114.6-256-256 114.6-256 256-256zM368 376v-240c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v88h-96v-88c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-88h96v88c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hospital-symbol.js
// module id = 1466
// module chunks = 0